export function ListTable({ caption, children, stickyActions = false, className = '' }) {
  return (
    <div className={`table-wrap ${className}`.trim()}>
      <table className={stickyActions ? 'data-table has-sticky-actions' : 'data-table'}>
        {caption ? <caption className="sr-only">{caption}</caption> : null}
        {children}
      </table>
    </div>
  );
}
